// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"3d5469a4","332":"3bf49c9a","972":"1df80970"}[chunkId] + ".chunk.css";
};